module.exports = __webpack_public_path__ + "assets/img/citizens.61ab8039.svg";